import { render, staticRenderFns } from "./IndexSessionsPage.vue?vue&type=template&id=5916630a&scoped=true&"
import script from "./IndexSessionsPage.vue?vue&type=script&lang=js&"
export * from "./IndexSessionsPage.vue?vue&type=script&lang=js&"
import style0 from "./IndexSessionsPage.vue?vue&type=style&index=0&id=5916630a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5916630a",
  null
  
)

export default component.exports